<template>
  <v-carousel
    cycle
    height="100vh"
    hide-delimiter-background
    show-arrows-on-hover
  >
    <v-carousel-item
      v-for="(slide, i) in slides"
      :src="slide"
      :key="i"
      class="headers"
    >
      <!-- <v-overlay :absolute="true"> -->
        <v-row class="fill-height" align="center" justify="center">
          <!-- <v-col class="text-h2 text-center white--text text-uppercase">
            Songket Indonesia<br />
            <span class="text-h3 text-capitalize">Connecting The Universe</span>
          </v-col> -->
        </v-row>
      <!-- </v-overlay> -->
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      slides: [
        require(`@/assets/img/banners/1.jpg`),
        require(`@/assets/img/banners/2.jpg`),
        require(`@/assets/img/banners/3.jpg`),
        require(`@/assets/img/banners/4.jpg`),
        require(`@/assets/img/banners/5.jpg`)
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
